import { FC, createContext, useContext, useMemo, useState, useCallback } from 'react'
import {
  QueryRequestContextProps,
  QueryState,
  WithChildren,
  initialQueryRequest,
} from '../../../../../../_metronic/helpers'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const [state, setState] = useState<QueryState>({
    ...initialQueryRequest.state,
    fixedSort: [{ field: 'data', order: 'asc' }],
  })

  const updateState = useCallback(
    (updates: Partial<QueryState>) => setState((prev) => ({ ...prev, ...updates })),
    []
  )

  const value = useMemo(() => ({ state, updateState }), [state, updateState])

  return <QueryRequestContext.Provider value={value}>{children}</QueryRequestContext.Provider>
}

export const useQueryRequest = () => useContext(QueryRequestContext)
